import { TableCell, TableRow, Tooltip } from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import styles from "pages/phNewPendingTasks/style.module.scss";

const SupportChat = () => {
  const tasksList = [
    {
      teachers_count: 12,
      teachers_allowed: 20,
      students_count: 95,
      students_allowed: 100,
    },
    {
      teachers_count: 30,
      teachers_allowed: 30,
      students_count: 250,
      students_allowed: 300,
    },
    {
      teachers_count: 15,
      teachers_allowed: 20,
      students_count: 100,
      students_allowed: 100,
    },
    {
      teachers_count: 20,
      teachers_allowed: 20,
      students_count: 160,
      students_allowed: 200,
    },
    {
      teachers_count: 25,
      teachers_allowed: 30,
      students_count: 100,
      students_allowed: 120,
    },
    {
      teachers_count: 18,
      teachers_allowed: 20,
      students_count: 140,
      students_allowed: 150,
    },
  ];

  return (
    <>
      {tasksList?.map((item: any, index: any, arr: any) => {
        return (
          <TableRow
          // className={classNames(index + 1 === arr.length && styles.lastCells)}
          >
            <TableCell>
              <div className={styles.nameCell}>
                <img
                  src={Images.UserPlaceholderImage}
                  alt="profile_picture"
                  className={styles.profilepic}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Jane Doe</label>
                  <label className={styles.emailLabel}>janedoe@gmail.com</label>
                </div>
              </div>
            </TableCell>
            <TableCell>03103212312</TableCell>
            <TableCell className={classNames(styles.statusCell)}>
              <label
                className={
                  item?.status === 1
                    ? styles.approved
                    : item?.status === 0
                    ? styles.rejected
                    : ""
                }
              >
                {item?.status ? "Signed" : "Not Signed Yet"}
              </label>
            </TableCell>

            <TableCell>
              <div className={styles.centerToCell}>
                {item?.teachers_count}/{item?.teachers_allowed}
              </div>
            </TableCell>
            <TableCell>
              <div className={styles.centerToCell}>
                {item?.students_count}/{item?.students_allowed}
              </div>
            </TableCell>
            <TableCell>
              <div className={styles.actionContainer}>
                <Tooltip arrow title="View Support Chat">
                  <div>
                    <Icons.EyeIcon className={styles.icons} />
                  </div>
                </Tooltip>
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export default SupportChat;
